export const TRANSLATIONS_ES_HOME_QUALITY_AND_ALERTS = {
  "home.alerts.title": "Requiere tu atencion",
  "home.alerts.viewAll": "Ver todas",
  "home.alerts.empty": "No hay alertas activas.",
  "home.alerts.loading": "Cargando...",
  "home.alerts.errorMessage": "No se pudieron cargar las alertas.",
  "home.alerts.retry": "Reintentar",
  "home.qaHarness.title": "Home IA QA",
  "home.qaHarness.subtitle": "Harness local para validar estados reales de Home IA",
  "home.qaHarness.copy": "Esta ruta interna renderiza los componentes reales de /home con fixtures tipados para capturar evidencia visual sin depender del backend ni de la sesión autenticada.",
  "home.qaHarness.section.connectionEyebrow": "Conectividad",
  "home.qaHarness.section.connectionTitle": "Estados SSE y pulse strip",
  "home.qaHarness.section.heroEyebrow": "Protagonista",
  "home.qaHarness.section.heroTitle": "Estados del next best decision",
  "home.qaHarness.section.listEyebrow": "Listado",
  "home.qaHarness.section.listTitle": "Resumen y lista compacta",
  "home.qaHarness.section.detailEyebrow": "Detalle",
  "home.qaHarness.section.detailTitle": "Estados del drawer de decisión",
  "home.qaHarness.section.feedbackEyebrow": "Feedback",
  "home.qaHarness.section.feedbackTitle": "Carga, éxito y error de acción",
  "home.qaHarness.section.supportEyebrow": "Soporte",
  "home.qaHarness.section.supportTitle": "Support band, fechas e historial",
  "home.qaHarness.card.connected": "Conectado",
  "home.qaHarness.card.connecting": "Conectando",
  "home.qaHarness.card.error": "Error de conexión",
  "home.qaHarness.card.readyHero": "Hero ejecutable",
  "home.qaHarness.card.blockedHero": "Hero en espera",
  "home.qaHarness.card.disabledHero": "Hero deshabilitado",
  "home.qaHarness.card.summary": "Resumen de estados",
  "home.qaHarness.card.allDecisions": "Lista completa",
  "home.qaHarness.card.blockedDecisions": "Lista filtrada: en espera",
  "home.qaHarness.card.executableDetail": "Detalle ejecutable",
  "home.qaHarness.card.blockedDetail": "Detalle con remediación",
  "home.qaHarness.card.disabledDetail": "Detalle deshabilitado",
  "home.qaHarness.card.lowConfidenceDetail": "Detalle con baja confianza",
  "home.qaHarness.card.formDetail": "Detalle con formulario",
  "home.qaHarness.card.loadingFeedback": "Acción en progreso",
  "home.qaHarness.card.successFeedback": "Feedback de éxito",
  "home.qaHarness.card.reevaluationFeedback": "Reevaluación en cola",
  "home.qaHarness.card.inspectionFeedback": "Resultado solo de inspección",
  "home.qaHarness.card.acknowledgedFeedback": "Acción de negocio reconocida",
  "home.qaHarness.card.manualCompletionFeedback": "Cierre manual confirmado",
  "home.qaHarness.card.replayFeedback": "Resultado repetido",
  "home.qaHarness.card.errorFeedback": "Feedback de error",
  "home.qaHarness.card.emptyDates": "Fechas vacías",
  "home.qaHarness.card.emptyActivity": "Actividad vacía",
  "home.qaHarness.card.emptyMetrics": "Métricas vacías",
  "home.qaHarness.controls.openDates": "Abrir panel de fechas",
  "home.qaHarness.controls.openHistory": "Abrir historial",
  "home.qaHarness.controls.resetPanels": "Restablecer paneles",
};
